import { IQueryParams } from '@/creditflowresearch/domain/vo/IQueryParams';
import { IRegion } from '@/creditflowresearch/domain/vo/Region';
import { UserPlanType } from '@creditflowresearch/user-plan/UserPlan';
import Region from '@/creditflowresearch/domain/Region';
import { selectDefaultRegionId } from '@/creditflowresearch/domain/Region/selectors/selectDefaultRegionId';
import type { IRegionAccessControl } from '@/creditflowresearch/domain/Region/selectors/hasRegionAccess';

export const selectRegionIdsFromQuery = (
  query: IQueryParams,
  regionsList: IRegion[],
  accessibleRegionsIds: string[],
  plan: UserPlanType,
  preferredRegionIds?: string[],
): string[] => {
  const queryRegionIds = Region.getIds(query.regions as string);

  if (queryRegionIds.length > 0) {
    return queryRegionIds;
  }

  const accessControl: IRegionAccessControl = {
    plan,
    accessibleRegionsIds,
  };

  const defaultRegionId = selectDefaultRegionId(regionsList, accessControl, preferredRegionIds);
  return defaultRegionId ? [defaultRegionId] : [Region.getDefaultId()];
};
